import { getEncarteThemeSearchResult } from "../../../../../services/EncarteThemeService";

const BASE_URL = process.env.REACT_APP_RESOURCES_BASE_URL;

/**
 * Fetch personalized encarte themes for a specific user.
 * @param {string} token - Auth token
 * @param {number} page - Page number (default 0)
 * @param {number} size - Page size (default 10)
 * @param {boolean} _premium - Unused (kept for ThemeListSlider signature compatibility)
 * @param {string} userEmail - User email
 * @returns {Promise<Page<EncarteTheme>>}
 */
export default function useFetchUserThemes() {
  const fetchUserThemes = async (
    token,
    page = 0,
    size = 10,
    _premium = false,
    userEmail,
  ) => {
    const emailParam = userEmail
      ? `&userEmail=${encodeURIComponent(userEmail)}`
      : "";
    const url = `${BASE_URL}/encartethemes/by-user?page=${page}&size=${size}${emailParam}`;

    const res = await fetch(url, {
      headers: { Authorization: token },
    });

    if (!res.ok) throw new Error("Failed to fetch personalized themes");

    const json = await res.json();
    return getEncarteThemeSearchResult(token, json);
  };

  return fetchUserThemes;
}
